import { render } from "./SMS.vue?vue&type=template&id=2341cdb5"
import script from "./SMS.vue?vue&type=script&lang=js"
export * from "./SMS.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__